import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `ProgressRoot`
};

export function useProgressStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          height: `40px`
        }
      ]
    }),
    []
  );
}
